import Api from "./Api";
import Utils from "../utilities/Utils";
import { News, NewsCenter } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class NewsController extends Api {
  static getNews(newsCenterId: string, params: object) {
    return fetch(
      `/api/news_centers/${newsCenterId}/news?${SearchHelper.getQueryString(
        params
      )}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }

  static getNewsPost(newsCenterId: string, id: string) {
    return fetch(`/api/news_centers/${newsCenterId}/news/${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(newsCenterId: string, news: News) {
    return fetch(`/api/news_centers/${newsCenterId}/news`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ news: news }),
    }).then((res) => res.json());
  }

  static update(newsCenterId: string, news: News) {
    return fetch(`/api/news_centers/${newsCenterId}/news/${news.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ news: news }),
    }).then((res) => res.json());
  }

  static delete(newsCenterId: string, id: string) {
    return fetch(`/api/news_centers/${newsCenterId}/news/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(
    newsCenterId: string,
    params: { id?: string }
  ): Promise<{
    news: News;
    news_center: NewsCenter;
  }> {
    return fetch(
      `/api/news_centers/${newsCenterId}/news/form?${Utils.encodeQueryData(
        params
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      }
    ).then((res) => res.json());
  }
}
